<template>
  <div>
    <vs-popup v-if="boardUserData && boardUserData.userData" class="profile-card"
      :title="boardUserData.userData.firstName + `'s Profile Card`" :active.sync="profileCardPopupActive"
      :button-close-hidden="true">
      <profile-card-popup :boardUserData="boardUserData" />
    </vs-popup>
    <vs-popup v-if="coachData && getBoardUserDataById(coachData.coachUserId)" class="profile-card" :title="getBoardUserDataById(coachData.coachUserId).userData.firstName +
      `'s Profile Card`
      " :active.sync="coachProfileCardPopupActive" :button-close-hidden="true">
      <profile-card-popup :boardUserData="getBoardUserDataById(coachData.coachUserId)" />
    </vs-popup>

    <vs-popup 
      class="relationship-popup" 
      :active.sync="addRelationPrompt" 
      :button-close-hidden="true"
    >
      <div class="p-2">
        <div class="flex justify-between items-center pb-3 mb-4 border-b border-gray-200">
          <h4 class="font-bold text-xl text-gray-800 m-0">Add Relationship</h4>
          <div 
            class="cursor-pointer hover:bg-gray-100 rounded-full p-1 transition-transform duration-300 hover:rotate-90 flex items-center justify-center" 
            @click="addRelationPrompt = false; selectedUser = '';"
          >
            <vs-icon icon="close" size="20px" color="#000000"></vs-icon>
          </div>
        </div>

        <label class="text-sm text-gray-600 mb-1 block font-semibold">Member</label>
        
        <main class="dropdown w-full mb-4" v-click-outside="toggleListVisibility">
          <vs-input 
            size="large" 
            class="dropdown__search w-full" 
            v-model="selectedUser" 
            v-on:input="searchOrgUser()"
            @focus="toggleListVisibility(true)" 
            placeholder="Search User" 
          />
          
          <div class="dropdown__icons mt-2">
            <img v-if="listVisible" @click="toggleListVisibility(!listVisible)"
              class="cursor-pointer transform rotate-180" src="@/assets/images/icons/arrow-drop.svg" alt="" />
            <img v-else class="cursor-pointer" @click="toggleListVisibility(!listVisible)"
              src="@/assets/images/icons/arrow-drop.svg" alt="" />
          </div>

          <vue-perfect-scrollbar v-if="searchedOrgUserArray.length > 0" class="dropdown__content"
            :class="listVisible ? 'block' : 'hidden'">
            <ul class="p-0 my-50">
              <li :class="selectedUser === user.userData.firstName + ' ' + user.userData.lastName ? 'option__selected' : ''" 
                @click="selectUser(user)" class="flex items-center" v-for="user in searchedOrgUserArray" :key="user._id">
                <vs-avatar size="30px" class="mr-2" v-if="user.userData.profilePictureUrl"
                  :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`" />
                <vs-avatar size="30px" class="mr-2" v-else :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  user && user.userData ? user.userData.firstName || '' : '', 
                  user && user.userData ? user.userData.lastName || '' : ''
                )}`" />
                                <div class="flex flex-col">
                  <span class="user-name text-left text-sm">
                    {{ user.userData.firstName }} {{ user.userData.lastName }}
                  </span>
                  <span class="text-xs text-gray-500 text-left">
                    {{ user.userData.email }}
                  </span>
                </div>
              </li>
            </ul>
          </vue-perfect-scrollbar>

          <vue-perfect-scrollbar v-if="searchedOrgUserArray.length === 0" class="dropdown__content h-10"
            :class="listVisible ? 'block' : 'hidden'">
            <ul class="p-0 my-2">
              <div class="flex justify-center user-name px-2 text-sm text-gray-500">
                User Not Found
              </div>
            </ul>
          </vue-perfect-scrollbar>
        </main>

        <label class="text-sm text-gray-600 mb-1 block font-semibold">Relationship</label>
        
        <v-select 
          class="w-full mb-4" 
          v-model="relationShipData.relation" 
          :options="orgRelationShip" 
          label="label"
        />

        <div v-if="relationShipData && relationShipData.relation"
          class="text-sm font-medium text-gray-700 mt-2 mb-4 capitalize p-2 bg-gray-100 rounded">
          {{ selectedUser }} <span class="mx-1 font-normal">is</span>
          {{ relationShipData.relation.label }} <span class="mx-1 font-normal">of</span>
          {{ boardUserData.userData.firstName }}
          {{ boardUserData.userData.lastName }}
        </div>

        <div class="flex justify-end mt-6 pt-2">
          <vs-button 
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
            class="font-semibold px-8" 
            :class="relationShipData && relationShipData.selectedUser && relationShipData.relation ? '' : 'opacity-50 pointer-events-none'"
            @click.native="saveRelation"
          >
            Save
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup 
      class="remove-relationship-popup" 
      :active.sync="removeRelationPrompt"
      :button-close-hidden="true"
    >
      <div class="p-3 text-center" v-if="selectedRelationToRemove && selectedRelationToRemove.userData">
        <!-- Close Icon -->
        <div class="flex justify-end mb-2">
          <div 
            class="cursor-pointer hover:bg-gray-100 rounded-full p-1 transition-all duration-200" 
            @click="removeRelationPrompt = false"
          >
            <vs-icon icon="close" size="18px" color="#9ca3af"></vs-icon>
          </div>
        </div>

        <!-- Section Title -->
        <h4 class="font-bold text-lg text-gray-800 mb-1 text-left">Relationship</h4>
        
        <!-- Summary text -->
        <p class="text-sm text-gray-600 mb-4 text-left">
          {{ selectedRelationToRemove.userData.firstName }} is 
          <span class="font-semibold text-gray-700">{{ getRelationName(selectedRelationToRemove.relationship) }}</span> of 
          {{ boardUserData.userData.firstName }}
        </p>
        
        <!-- Subtle details panel -->
        <div class="flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-white shadow-sm">
          <div class="flex items-center">
            <vs-avatar 
              v-if="selectedRelationToRemove.userData.profilePictureUrl" 
              size="40px" 
              :src="constants.s3Bucket + '/editor/profile-pictures/' + selectedRelationToRemove.userData.profilePictureUrl" 
              class="m-0 mr-3 shadow-xs"
            />
            <vs-avatar 
              v-else 
              size="40px" 
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                selectedRelationToRemove && selectedRelationToRemove.userData ? selectedRelationToRemove.userData.firstName || '' : '', 
                selectedRelationToRemove && selectedRelationToRemove.userData ? selectedRelationToRemove.userData.lastName || '' : ''
              )}`" 
              class="m-0 mr-3 shadow-xs"
            />
            <div class="flex flex-col text-left leading-tight">
              <span class="font-bold text-sm text-gray-900">{{ selectedRelationToRemove.userData.firstName }} {{ selectedRelationToRemove.userData.lastName }}</span>
              <span class="text-xs text-gray-500">{{ selectedRelationToRemove.userData.email }}</span>
            </div>
          </div>
          
          <!-- Subtle Red Circular Minus Button -->
          <div 
            @click="deleteRelationship" 
            class="w-6 h-6 flex items-center justify-center bg-red-100 hover:bg-red-200 rounded-full cursor-pointer transition-all duration-200"
          >
            <div class="bg-red-600" style="width: 10px; height: 2px; border-radius: 1px;"></div>
          </div>
        </div>
      </div>
    </vs-popup>

    <div v-if="currentBoard" class="user-card---kanban">
      <div v-if="userCardView === 'minimized' || !userCardView">
          <div class="relative items-center">
            
            <!-- TOP RIGHT BUTTONS -->
            <div class="absolute top-0 right-0 mt-3 mr-3 flex items-center z-50" style="gap: 8px;">
              <!-- ADD RELATIONSHIP BUTTON -->
              <div @click.stop.prevent="openRelationPrompt" class="cursor-pointer">
                <vx-tooltip text="Add Relationship">
                  <div class="bg-green-500 text-white rounded-full flex items-center justify-center shadow-sm hover:bg-green-600 transition" style="width: 20px; height: 20px;">
                    <vs-icon icon="add" size="16px"></vs-icon>
                  </div>
                </vx-tooltip>
              </div>
              
              <!-- ADD NOTES BUTTON -->
              <div
                  class="flex items-center justify-center"
                  style="width:18px;height:18px;"
                >
                  <feather-icon
                    icon="MessageCircleIcon"
                    svgClasses="w-5 h-5"
                    style="color:#798ba0;"
                  />
                </div>

              <div @click.stop.prevent="confirmRemoveUser" class="cursor-pointer">
                <vx-tooltip text="Remove from Board">
                  <div class="bg-red-500 text-white rounded-full flex items-center justify-center shadow-sm hover:bg-red-600 transition"
                      style="width: 20px; height: 20px;">
                    <feather-icon
                      icon="MinusIcon"  
                      svgClasses="w-4 h-4 text-white"
                    />
                  </div>
                </vx-tooltip>
              </div>
            </div>

            <vx-tooltip text="Click to view user progress" class="block w-full">
              <div class="w-full cursor-pointer pb-2" @click.stop="profileCardPopupActive = true">
                
                <div class="flex items-center">
                  <!-- Avatar Container -->
                  <div class="flex" style="position: relative">
                    <vs-avatar v-if="boardUserData && boardUserData.userData && boardUserData.userData.profilePictureUrl" size="32px" :src="constants.s3Bucket + '/editor/profile-pictures/' + boardUserData.userData.profilePictureUrl" />
                      <vs-avatar v-else size="32px" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                        boardUserData && boardUserData.userData ? boardUserData.userData.firstName || '' : '', 
                        boardUserData && boardUserData.userData ? boardUserData.userData.lastName || '' : ''
                      )}`" />                    
                    <!-- NEW: ROLE INITIAL BADGE (Replaced C/T tags) -->
                    <div v-if="getRoleInitial(userAccessLevel)" class="absolute z-20" style="bottom: -2px; right: -4px;">
                      <vx-tooltip :text="getRoleLabel(userAccessLevel)" position="top">
                        <div class="flex items-center justify-center rounded-full text-white font-bold cursor-pointer"
                             style="width: 16px; height: 16px; font-size: 9px; border: 2px solid white; box-sizing: content-box;"
                             :style="{ backgroundColor: getRoleColor(userAccessLevel) }">
                          {{ getRoleInitial(userAccessLevel) }}
                        </div>
                      </vx-tooltip>
                    </div>
                  </div>

                  <!-- Text Container -->
                  <div class="relative m-3 w-full text-left pr-24">
                    <!-- FIX: Added 'leading-tight' so wrapped names don't have awkward vertical spacing -->
                    <h5 class="text-left font-semibold text-gray-800 leading-tight" style="word-wrap: break-word;">
                      {{ boardUserData.userData.firstName | title }}
                      {{ boardUserData.userData.lastName | title }}
                    </h5>
                    <p v-if="boardUserData.userData.profession" class="text-left mt-1 text-xs text-gray-500">
                      {{ boardUserData.userData.profession }}
                    </p>
                  </div>
                </div>

                <!-- BOTTOM ROW: Relationships Footer -->
                <div v-if="existingRelationships.length > 0" class="flex items-center" style="margin-left: 44px; margin-top: -4px;">
                  <div v-for="(rel, index) in existingRelationships" :key="index">
                    <vx-tooltip :text="`${rel.userData.firstName} is ${getRelationName(rel.relationship)} of ${boardUserData.userData.firstName}`">
                      <vs-avatar 
                        v-if="rel.userData && rel.userData.profilePictureUrl" 
                        size="20px" 
                        class="-m-1 relative z-10 hover:z-50 transition-all duration-200 cursor-pointer"
                        style="border: 2px solid white;"
                        :src="constants.s3Bucket + '/editor/profile-pictures/' + rel.userData.profilePictureUrl" 
                        @click.stop="openRemoveRelationPrompt(rel)"
                      />
                      <vs-avatar 
                        v-else-if="rel.userData"
                        size="20px" 
                        class="-m-1 relative z-10 hover:z-50 transition-all duration-200 cursor-pointer"
                        style="border: 2px solid white;"
                        :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                          rel.userData.firstName || '', 
                          rel.userData.lastName || ''
                        )}`" 
                        @click.stop="openRemoveRelationPrompt(rel)"
                      />

                    </vx-tooltip>
                    <div v-show="hasAttachments" class="absolute bottom-0 right-0 mb-2 mr-3 z-10">
              <a :href="latestAttachmentUrl" target="_blank" title="View/Download Attached File" @click.stop>
                <feather-icon 
                  icon="LinkIcon" 
                  class="w-4 h-4 cursor-pointer text-primary hover:text-blue-700 transition-colors" 
                />
              </a>
            </div>
                  </div>
                </div>

              </div>
            </vx-tooltip>
          </div>

        <div class="flex justify-between mx-2 mt-2 mb-0"></div>
        <hr v-if="showNotes" class="mt-1 mb-3" style="border-top: #efefef" />
        <div v-show="fetchingNotes" id="div-notes-with-loading" class="vs-con-loading__container"
          style="min-height: 50px"></div>
        <div v-if="showNotes && !fetchingNotes">
          <div class="m-2 mb-5">
            <vs-input class="w-full" placeholder="Add a Note" v-model="note" @keyup.enter="saveNote" @blur="saveNote" />
          </div>
          <vx-timeline :data="notesData" @deleteKanbanNote="deleteKanbanNote" />
        </div>
      </div>
      <div v-else>
        <!-- Removed redundant v-if from here as well -->
        <div>
          <div class="flex items-center">

            <div class="flex" style="position: relative">
              <vs-avatar v-if="boardUserData.userData.profilePictureUrl" size="60px" 
                :src="constants.s3Bucket + '/editor/profile-pictures/' + boardUserData.userData.profilePictureUrl" 
                @click.stop="profileCardPopupActive = true" />
              <vs-avatar v-else size="60px" 
                :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  boardUserData && boardUserData.userData ? boardUserData.userData.firstName || '' : '', 
                  boardUserData && boardUserData.userData ? boardUserData.userData.lastName || '' : ''
                )}`" 
                @click.stop="profileCardPopupActive = true" />
              
              <!-- Old legacy image badge -->
              <img v-if="((boardUserData && boardUserData.boardUserConfigData && boardUserData.boardUserConfigData.userType === 'coach') || (boardUserData && boardUserData.boardUserConfig && boardUserData.boardUserConfig.userType === 'coach')) && currentBoard.installedApps && currentBoard.installedApps.includes('coach')" width="32px" :src="require('@/assets/images/boards/mentor-badge.svg')" style="position: absolute; right: 0px; bottom: -9px" alt="" />

              <!-- NEW: ROLE INITIAL BADGE (Bigger for 60px Avatar) -->
              <div v-if="getRoleInitial(userAccessLevel)" class="absolute z-20" style="bottom: 2px; right: -2px;">
                <vx-tooltip :text="getRoleLabel(userAccessLevel)" position="top">
                  <div class="flex items-center justify-center rounded-full text-white font-bold cursor-pointer shadow-sm"
                       style="width: 22px; height: 22px; font-size: 12px; border: 2.5px solid white; box-sizing: content-box;"
                       :style="{ backgroundColor: getRoleColor(userAccessLevel) }">
                    {{ getRoleInitial(userAccessLevel) }}
                  </div>
                </vx-tooltip>
              </div>
            </div>
            <div class="relative m-3">
              <h4 class="mb-1 items-left">
                {{ boardUserData.userData.firstName | title }}
                {{ boardUserData.userData.lastName | title }}
              </h4>
              <p v-if="boardUserData.userData.profession" class="items-left">
                {{ boardUserData.userData.profession }}
              </p>
            </div>
          </div>
          <p v-if="boardUserData.userData.careerObjective" class="my-3 p-1">
            {{ boardUserData.userData.careerObjective }}
          </p>
          <div class="mb-3 p-1 kanban-skill-main" v-if="
            boardUserData.userData.extraCurricular[0] &&
            boardUserData.userData.extraCurricular[0].skills &&
            boardUserData.userData.extraCurricular[0].skills.length
          ">
            <span v-for="(skill, index) in boardUserData.userData.extraCurricular[0]
              .skills" :key="index" class="kanban-skill mr-3 mb-1">{{ skill.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VxTimeline from "./components/VxTimeline";
import constants from "@/constants.js";
import ProfileCardPopup from "../../components/ProfileCardPopup.vue";
import vSelect from 'vue-select'; 
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    boardUserData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    userCardView: {
      type: String,
      required: true,
      default: "minimized",
    },
    kanbanId: {
      type: String,
      required: true,
    },
    kanbanColId: {
      type: String,
      required: true,
    },
  },
  components: {
    VxTimeline,
    ProfileCardPopup, vSelect, VuePerfectScrollbar 
  },
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  data() {
    return {
      constants,
      profileCardPopupActive: false,
      notesData: [],
      note: "",
      showNotes: false,
      skillRating: 0,
      fetchingNotes: false,
      showCopyIcon: false,
      profilePercent: 0,
      localCoachData: {},
      coachProfileCardPopupActive: false,
      isUserCoach: false, // Keeping these in case used elsewhere by API logic
      hasCoach: false,    // Keeping these in case used elsewhere by API logic
      existingRelationships: [],
      addRelationPrompt: false,
      orgEmployees: [],
      searchedOrgUserArray: [],
      selectedUser: "",
      listVisible: false,
      relationShipData: {},
      orgRelationShip: [],
      removeRelationPrompt: false,
      userAttachments: [],
      isUploadingAttachment: false,
      selectedRelationToRemove: null,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
    boardUserName() {
      return this.boardUserData &&
        this.boardUserData.userData &&
        this.boardUserData.userData.firstName
        ? `${this.boardUserData.userData.firstName} ${this.boardUserData.userData.lastName}`
        : "";
    },
    hasAttachments() {
      // Returns true if our SQLite API returned files, OR if MongoDB has legacy files
      return (this.userAttachments && this.userAttachments.length > 0) || 
             (this.boardUserData.attachments && this.boardUserData.attachments.length > 0) || 
             (this.boardUserData.userData && this.boardUserData.userData.attachments && this.boardUserData.userData.attachments.length > 0);
    },
    
    latestAttachmentUrl() {
      // 1. If file is in our new SQLite API, return the direct download link
      if (this.userAttachments && this.userAttachments.length > 0) {
         const pyApiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
         return `${pyApiUrl}/api/v2/kanban-attachments/${this.userAttachments[0].id}`;
      }
      // 2. Fallback for old MongoDB attachments
      if (this.boardUserData.attachments && this.boardUserData.attachments.length > 0) {
         return this.boardUserData.attachments[0].url || this.boardUserData.attachments[0];
      }
      if (this.boardUserData.userData && this.boardUserData.userData.attachments && this.boardUserData.userData.attachments.length > 0) {
         return this.boardUserData.userData.attachments[0].url || this.boardUserData.userData.attachments[0];
      }
      return '#';
    },
    coachData() {
      return this.boardUserData && this.boardUserData.userData
        ? this.$store.state.boards.coach[this.boardUserData.userData._id]
        : {};
    },
    currentBoardUsers() {
      return this.$store.state.boards.currentBoardUsers;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    // ---- NEW COMPUTEDS FOR ROLES ----
    roles() {
      const config = this.$store.state.organization.organizationConfiguration;
      if (config && config.roleTitle && config.roleTitle.values) {
          return config.roleTitle.values;
      }
      return [];
    },
    talentPoolUser() {
      // Find the specific user from the Talent Pool store to get accessLevel
      if (!this.boardUserData || !this.boardUserData.userData) return null;
      const targetUserId = String(this.boardUserData.userData._id);
      const employees = this.$store.state.organization.employees || [];
      return employees.find(emp => 
         String(emp.userId) === targetUserId || 
         (emp.userData && String(emp.userData._id) === targetUserId)
      );
    },
    userAccessLevel() {
      return this.talentPoolUser ? this.talentPoolUser.accessLevel : null;
    },
    availableRelationships() {
      const config = this.$store.state.organization.organizationConfiguration;
      if (config && config.relationship && config.relationship.values) {
        return config.relationship.values;
      }
      return [
        { label: 'Coach', key: 'coach' }, { label: 'Mentor', key: 'mentor' },
        { label: 'Advisor', key: 'advisor' }, { label: 'Trainee', key: 'trainee' },
        { label: 'Colleague', key: 'colleague' }
      ];
    },
  },
  watch: {
    boardUserData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.userData && this.currentBoard) this.fetchUserAttachments();
      }
    },
    currentBoard: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.boardUserData && this.boardUserData.userData) this.fetchUserAttachments();
      }
    }
  },
  methods: {
    // ---- NEW METHODS FOR ROLES ----
    getRoleLabel(accessLevel) {
      if (!accessLevel || !this.roles) return '';
      const role = this.roles.find(r => r.key === accessLevel);
      return role ? role.label : accessLevel;
    },
    getRoleInitial(accessLevel) {
      const label = this.getRoleLabel(accessLevel);
      return label ? label.charAt(0).toUpperCase() : '';
    },
    getRoleColor(accessLevel) {
      if (!accessLevel) return '#94a3b8';
      const colors = ['#f56565', '#ed8936', '#ecc94b', '#48bb78', '#38b2ac', '#4299e1', '#667eea', '#9f7aea', '#ed64a6', '#f687b3'];
      let hash = 0;
      for (let i = 0; i < accessLevel.length; i++) {
        hash = accessLevel.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },
    // --------------------------------
    saveNote() {
      if (
        !this.note ||
        !this.kanbanId ||
        !this.kanbanColId ||
        !this.boardUserData
      )
        return;

      const kanbanObj = {
        kanbanId: this.kanbanId,
        boardUserId: this.boardUserData._id,
        userId: this.userData._id,
        boardId: this.currentBoard._id,
        note: this.note,
      };

      const boardTitle = this.currentBoard.title;
      const organizationId = this.orgData._id;

      this.$store
        .dispatch("kanban/saveUserNote", {
          kanbanObj,
          boardTitle,
          boardUserName: this.boardUserName,
          organizationId,
        })
        .then((res) => {
          this.notesData.unshift(res);
          this.note = "";
        });
    },
    showUserNotes() {
      if (this.showNotes) {
        this.showNotes = false;
      } else {
        this.fetchNotes();
        this.showNotes = true;
      }
    },
    async fetchUserAttachments() {
      if (!this.currentBoard || !this.boardUserData || !this.boardUserData.userData) return;
      
      try {
        const token = localStorage.getItem('accessToken') || this.$store.state.bearerToken;
        const pyApiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
        const boardId = this.currentBoard._id;
        const userId = this.boardUserData.userData._id;

        const res = await fetch(`${pyApiUrl}/api/v2/boards/${boardId}/users/${userId}/attachments`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        const data = await res.json();
        if (data.status === 'success') {
          this.userAttachments = data.data; // Silently stores the file data
        }
      } catch(e) {
        console.error("Failed to fetch user attachments:", e);
      }
    },

    async uploadUserAttachment(e) {
      const file = e.target.files[0];
      if (!file) return;
      
      this.isUploadingAttachment = true;
      this.$vs.loading({ type: 'radius' });

      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('org_id', this.orgData._id);

        const token = localStorage.getItem('accessToken') || this.$store.state.bearerToken;
        const pyApiUrl = process.env.VUE_APP_API_URL;
        const boardId = this.currentBoard._id;
        const userId = this.boardUserData.userData._id;

        const res = await fetch(`${pyApiUrl}/api/v2/boards/${boardId}/users/${userId}/attachments`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` },
          body: formData
        });

        if (res.ok) {
          this.$vs.notify({ color: 'success', title: 'Success', text: 'Attachment uploaded successfully' });
          this.fetchUserAttachments(); // Refresh the list so the link icon appears instantly!
        } else {
          const err = await res.json();
          this.$vs.notify({ color: 'danger', title: 'Upload Failed', text: err.detail || 'Could not upload file' });
        }
      } catch(e) {
        console.error(e);
        this.$vs.notify({ color: 'danger', title: 'Error', text: 'Network error during upload' });
      } finally {
        this.isUploadingAttachment = false;
        this.$vs.loading.close();
        this.$refs.kanbanAttachmentInput.value = ""; // Reset input so you can upload the same file again if needed
      }
    },
    fetchNotes() {
      if (!this.kanbanId || !this.boardUserData) return;
      this.fetchingNotes = true;
      this.$vs.loading({
        container: "#div-notes-with-loading",
        scale: 0.5,
      });

      this.$store
        .dispatch("kanban/fetchAllUserNotes", {
          boardUserId: this.boardUserData._id,
          kanbanId: this.kanbanId,
        })
        .then((res) => {
          this.notesData = res.data;
          this.fetchingNotes = false;

          this.$vs.loading.close("#div-notes-with-loading > .con-vs-loading");
        });
    },
    deleteKanbanNote(kanbanNoteId) {
      if (!kanbanNoteId) return;

      const boardTitle = this.currentBoard.title;
      const organizationId = this.orgData._id;

      this.$store
        .dispatch("kanban/deleteUserNote", {
          kanbanNoteId,
          boardTitle,
          boardUserName: this.boardUserName,
          organizationId,
        })
        .then((res) => {
          const i = this.notesData.findIndex((nd) => {
            return nd._id === kanbanNoteId;
          });
          this.notesData.splice(i, 1);
        });
    },
    copyUserProfileLink() {
      if (!this.boardUserData) return "#";

      const userProfileLink = `${constants.url}/${this.boardUserData.boardData.slug}/${this.boardUserData._id}/profile/${this.boardUserData.userData.slug}`;
      navigator.clipboard.writeText(userProfileLink);

      this.$store.dispatch("organization/logOrganizationActivity", {
        organizationId: this.currentBoard.organizationId,
        logObj: {
          logText: `Copied ${this.currentBoard.title} board user (${this.boardUserName})'s profile link`,
          status: "active",
          boardId: this.currentBoard._id,
          userId: this.userData._id,
        },
      });
    },
    assignCoach(traineeId) {
      try {
        this.$emit("assignCoach", traineeId);
      } catch (error) {
        console.error(error);
      }
    },
    getBoardUserDataById(userId) {
      return this.currentBoardUsers.find((boardUser) => {
        return userId == boardUser.userId;
      });
    },
    async checkCoachStatus() {
      try {
        if (!this.boardUserData || !this.boardUserData.userData || !this.orgData) return;
        const userId = this.boardUserData.userData._id;
        const orgId = this.orgData._id;
        const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
        const pyApiUrl = process.env.VUE_APP_API_URL;
        
        const url = `${pyApiUrl}/api/v2/organization/${orgId}/user/${userId}/is-coach`;
        const response = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
        const res = await response.json();

        if (res && res.status === "success") {
          this.isUserCoach = res.is_coach; 
          this.hasCoach = res.has_coach;   
        }
      } catch(e) { console.warn(e); }
    },
   openRelationPrompt() {
      this.addRelationPrompt = true;
      this.relationShipData = {};
      this.selectedUser = "";
      this.fetchOrgEmployees(this.orgData._id);
      this.getOrgRelation(this.orgData._id);
    },
    fetchOrgEmployees(orgId) {
      if (this.orgEmployees.length === 0) {
        this.$store.dispatch("organization/getAllOrgEmployees", orgId).then((res) => {
          if (res && res.data && res.data.length > 0) {
            const currentUserId = String(this.boardUserData.userData._id);
            this.orgEmployees = res.data.filter(emp => {
              if (!emp || !emp.userData) return false;
              const empId = String(emp.userData._id || emp.userId || "");
              return empId !== currentUserId; 
            });
            this.searchedOrgUserArray = this.orgEmployees;
          }
        });
      }
    },

    searchOrgUser() {
      const currentUserId = String(this.boardUserData.userData._id);
      let allExceptSelf = this.orgEmployees.filter(emp => {
        if (!emp || !emp.userData) return false;
        const empId = String(emp.userData._id || emp.userId || "");
        return empId !== currentUserId;
      });
      
      if (this.selectedUser) {
        this.searchedOrgUserArray = allExceptSelf.filter((user) => {
          const fname = user.userData.firstName || "";
          const lname = user.userData.lastName || "";
          const full = `${fname} ${lname}`.toLowerCase();
          return full.includes(this.selectedUser.toLowerCase());
        });
      } else {
        this.searchedOrgUserArray = allExceptSelf;
      }
    },

    toggleListVisibility(value) {
      if (typeof value === "boolean") {
        this.listVisible = value;
      } else {
        this.listVisible = false;
      }
    },
    selectUser(user) {
      this.selectedUser = user.userData.firstName + " " + (user.userData.lastName || "");
      this.relationShipData.selectedUser = user;
      this.listVisible = false;
    },
    getOrgRelation(orgId) {
      this.$store.dispatch("organization/fetchOrganizationConfig", { organizationId: orgId }).then((res) => {
        if (res && res.relationship) {
          this.orgRelationShip = res.relationship.values.filter((item) => item.label !== "Add Configuration");
        }
      });
    },
    
     getRelationName(relationObj) {
      if (relationObj && relationObj.key) {
        let orgRelations = this.$store.state.organization.organizationConfiguration?.relationship?.values || [];
        let relationItem = orgRelations.find(relation => relation.key === relationObj.key);
        return relationItem ? relationItem.label : (relationObj.label || relationObj.key);
      }
      return "";
    },
    async fetchExistingRelationships() {
      try {
        if (!this.boardUserData || !this.boardUserData.userData || !this.orgData) return;
        
        const targetUserId = String(this.boardUserData.userData._id);
        let employees = this.$store.state.organization.employees;
        
        if (!employees || employees.length === 0) {
           await this.$store.dispatch("organization/fetchAllEmployees", {
              organizationId: this.orgData._id,
           });
           employees = this.$store.state.organization.employees || [];
        }
        
        // Fetch organization configuration if missing from the store
        let config = this.$store.state.organization.organizationConfiguration;
        if (!config || !config.relationship) {
          config = await this.$store.dispatch("organization/fetchOrganizationConfig", { 
            organizationId: this.orgData._id 
          });
        }

        const orgEmployee = employees.find(emp => 
           String(emp.userId) === targetUserId || 
           (emp.userData && String(emp.userData._id) === targetUserId)
        );

        if (orgEmployee && orgEmployee.employeeRelationshipsData) {
           const activeRelationKeys = config?.relationship?.values?.map(r => r.key) || [];
           
           if (activeRelationKeys.length > 0) {
             this.existingRelationships = orgEmployee.employeeRelationshipsData.filter(rel => 
                rel.relationship && activeRelationKeys.includes(rel.relationship.key)
             );
           } else {
             this.existingRelationships = orgEmployee.employeeRelationshipsData;
           }
        } else {
           this.existingRelationships = [];
        }
      } catch(e) {
        console.warn("Failed to fetch existing relationships", e);
      }
    },

    openRemoveRelationPrompt(relation) {
      this.selectedRelationToRemove = relation;
      this.removeRelationPrompt = true;
    },

    async syncCoachUserDB(userId, email) {
      if (!userId || !email) return;
      try {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
        const pyApiUrl = process.env.VUE_APP_API_URL;
        
        // Await the fetch
        const res = await fetch(`${pyApiUrl}/api/v2/coach/sync-user`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
          },
          body: JSON.stringify({
            user_id: userId,
            org_id: this.orgData._id,
            email: email
          })
        });

        // Log the response so you can see the update status in the browser console
        const data = await res.json();
        console.log(`[Coach Sync] Status for ${email}:`, data);
        
      } catch (err) {
        console.warn("[Coach Sync] Failed to sync coach DB", err);
      }
    },

    async deleteRelationship() {
      if (!this.selectedRelationToRemove) return;

      const payload = {
        // Add _id to guarantee backend deletes it safely
        _id: this.selectedRelationToRemove._id,
        id: this.selectedRelationToRemove._id,
        userIdFrom: this.selectedRelationToRemove.userIdFrom,
        userIdTo: this.selectedRelationToRemove.userIdTo,
        relationship: this.selectedRelationToRemove.relationship,
        organizationId: this.orgData._id,
      };
      
      const removedRelId = this.selectedRelationToRemove._id;
      const removedUserData = this.selectedRelationToRemove.userData;
      const removedOtherUserId = this.selectedRelationToRemove.other_user_id;
      
      try {
        // 1. Remove from the local Kanban card array
        if (this.existingRelationships && this.existingRelationships.length > 0) {
          this.existingRelationships = this.existingRelationships.filter(
            rel => rel._id !== removedRelId
          );
        }

        // 2. THE FIX: Remove from ALL users in the Vuex Store (Talent Pool UI)
        // This ensures the avatar is removed from BOTH people involved in the relationship!
        const employees = this.$store.state.organization.employees;
        if (employees && employees.length > 0) {
          for (let i = 0; i < employees.length; i++) {
            if (employees[i].employeeRelationshipsData && employees[i].employeeRelationshipsData.length > 0) {
              employees[i].employeeRelationshipsData = employees[i].employeeRelationshipsData.filter(
                r => r._id !== removedRelId
              );
            }
          }
        }

        // Close prompt instantly
        this.removeRelationPrompt = false;
        this.selectedRelationToRemove = null;
        this.$forceUpdate();

        // 3. Dispatch to Backend
        const dispatchResult = this.$store.dispatch("organization/removeEmployeeRelationship", payload);
        if (dispatchResult && typeof dispatchResult.then === 'function') {
          await dispatchResult;
        }

        this.$vs.notify({ color: "success", text: "Relationship Removed Successfully" });
        
        // 4. Force a hard fetch to ensure absolute consistency with backend
        await this.$store.dispatch("organization/fetchAllEmployees", { organizationId: this.orgData._id });
        if (typeof this.checkCoachStatus === 'function') this.checkCoachStatus(); 
        
        // 5. Update the MySQL Coach Database
        this.syncCoachUserDB(this.boardUserData.userData._id, this.boardUserData.userData.email);
        if (removedUserData) {
           this.syncCoachUserDB(removedUserData._id || removedOtherUserId, removedUserData.email);
        }
        
      } catch (err) {
        console.error("Deletion error:", err);
        this.$vs.notify({ color: "danger", text: "Failed to remove relationship." });
        this.fetchExistingRelationships();
      }
    },

    saveRelation() {
      const payload = {
        userIdFrom: this.boardUserData.userData._id, 
        userIdTo: this.relationShipData.selectedUser.userId,
        assignedByUserId: this.userData._id,
        relationship: this.relationShipData.relation,
        organizationId: this.orgData._id,
      };
      
      this.$store.dispatch("organization/saveEmployeeRelation", payload)
        .then(async (res) => {
          
          // 1. INSTANT OPTIMISTIC UI UPDATE (Matches Talent Pool logic)
          const newRelation = {
            ...payload,
            userData: this.relationShipData.selectedUser.userData,
            _id: res.data && res.data._id ? res.data._id : Math.random().toString(36).substr(2, 9) // Temp ID
          };
          this.existingRelationships.push(newRelation);
          this.$forceUpdate();

          this.$vs.notify({ color: "success", text: "Relationship Added Successfully" });
          
          // 2. Background Sync
          await this.$store.dispatch("organization/fetchAllEmployees", { organizationId: this.orgData._id });
          await this.fetchExistingRelationships(); // Overwrites temp ID with real DB ID
          this.checkCoachStatus(); 
          
          // 3. Update the MySQL Coach Database
          this.syncCoachUserDB(this.boardUserData.userData._id, this.boardUserData.userData.email);
          this.syncCoachUserDB(this.relationShipData.selectedUser.userId, this.relationShipData.selectedUser.userData.email);
        })
        .catch((err) => {
           console.error(err);
           this.$vs.notify({ color: "danger", text: "Failed to add relationship." });
        })
        .finally(() => {
          this.addRelationPrompt = false;
        });
    },

    confirmRemoveUser() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove User',
        text: `Are you sure you want to completely remove ${this.boardUserData.userData.firstName} from this board?`,
        accept: this.executeRemoveUser
      });
    },

    async executeRemoveUser() {
      try {
        const boardId = this.currentBoard._id;
        const userId = this.boardUserData.userData._id;
        const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
        const pyApiUrl = process.env.VUE_APP_API_URL;
        
        const res = await fetch(`${pyApiUrl}/api/v2/boards/${boardId}/users/${userId}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        const data = await res.json();

        if(data.status === 'success') {
          this.$vs.notify({ color: 'success', title: 'Removed', text: 'User removed from board successfully.' });
          
          this.$store.dispatch('kanban/getKanbanDataV2', boardId);
          this.$store.dispatch('boards/fetchCurrentBoardUsers', boardId);
        } else {
          throw new Error("API failed");
        }
      } catch(err) {
        console.error(err);
        this.$vs.notify({ color: 'danger', title: 'Error', text: 'Failed to remove user from board.' });
      }
    },
  },
  created() { 
    this.checkCoachStatus(); 
    this.fetchExistingRelationships(); 
    this.fetchUserAttachments();
  },
};
</script>

<style scoped>
/* Same existing styles here */
.user-name--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  letter-spacing: -0.02em;
  text-transform: capitalize;
  color: #192a46;
}
.user-name--item span {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #636175;
}
.level--item {
  background: rgba(36, 98, 238, 0.1);
  border-radius: 4px;
}
.level--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #2462ee;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
}
.user-details--item .location {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #a3a3a3;
}
.message-btn {
  background: #f4f6f8;
  border-radius: 6px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #081343;
}
.profile-card .name {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: -0.02em;
  color: #30384b;
}
.profile-card .role-title {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  color: #798ba0;
}
.profile-card .current-location,
.profile-card .email {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #b2bac8;
}
.profile-card .heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #b2bac8;
}
.profile-card .content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  color: #798ba0;
}
.kanban-skill {
  background: rgba(var(--vs-primary), 0.2) !important;
  border-radius: 4px;
  color: rgba(var(--vs-primary), 1) !important;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 10px;
}
.kanban-skill-main:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}
.profile-card>>>.vs-popup--header {
  display: none !important;
}
.profile-card>>>.vs-popup {
  width: 950px;
}
.con-vs-popup>>>.vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown__icons {
  padding: 0.75rem 0.75rem 0 0;
  position: absolute;
  right: 0;
  top: 0;
}
.dropdown__icons img {
  width: 1.75rem;
  height: 1.75rem;
  background: #fff;
}
.dropdown__content {
  width: 100%;
  height: auto;
  max-height: 200px;
  position: absolute;
  top: 100%;
  left: 0;
  overflow: hidden;
  z-index: 100;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}
.dropdown__content ul {
  list-style-type: none;
}
.dropdown__content ul .option__selected {
  background: #989898;
  color: #fff;
}
.dropdown__content ul li {
  padding: 0.3rem 0.75rem;
  cursor: pointer;
}
.dropdown__content ul li .user-name {
  font-weight: 600;
}
.dropdown__content ul li:hover {
  background: #989898;
  color: #fff;
}
.relationship-popup >>> .vs-popup--header {
  display: none !important;
}
.relationship-popup >>> .vs-popup--content {
  padding: 0 !important;
  width: 100% !important;
  overflow: visible !important; 
}
.remove-relationship-popup >>> .vs-popup--header {
  display: none !important;
}

.remove-relationship-popup >>> .vs-popup {
  width: 400px !important;
  max-width: 95vw !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
}

.remove-relationship-popup >>> .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
}
</style>